import React from "react";
import Button from "../Button/Button";
import Tags from "../Tags/Tags";
import "./Showcase.css";

const Showcase = ({
    image,
    title,
    description,
    code,
    preview,
    firstBtn,
    secondBtn,
    firstIcon,
    secondIcon,
    outsideWebsite,
    tags,
}) => {
    return (
        <section className='showcase'>
            <div id='container' className='showcase-container'>
                <div className={`col on-hover-tags ${title === "My Resume" ? "no-overlay" : ""}`}>
                    <img src={image} alt='showcase' />
                    <div className='tags'>
                        <div className='tags-container col'>
                            <div className='col'>
                                {tags.map((tag, idx) => {
                                    return (
                                        <Tags
                                            bgColor={tag.bgColor && tag.bgColor}
                                            key={idx}
                                            label={tag.label}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col dir-col'>
                    <div>
                        <h1>{title}</h1>
                        <p>{description}</p>
                        {firstBtn && (
                            <Button
                                className='btn'
                                label={firstBtn}
                                firstStyle={false}
                                to={{ pathname: code }}
                                outsideWebsite={outsideWebsite}
                                buttonGroup={true}
                                icon={firstIcon}
                            />
                        )}
                        {secondBtn && (
                            <Button
                                className='btn'
                                label={secondBtn}
                                firstStyle={true}
                                to={{ pathname: preview }}
                                outsideWebsite={true}
                                icon={secondIcon}
                            />
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export const iconStyle = {
    marginRight: "8px",
    fontSize: "1.125rem",
    marginBottom: "-3px",
};

Showcase.defaultProps = {
    outsideWebsite: true,
};

export default Showcase;
